module.exports = __webpack_public_path__ + "img/ill-home-projects-header.4ddfe110.svg";